/*
    create by BaiZhiming 2016-2-23
*/
'use strict';
angular.module('manageCfg.roleManageMent.permissionAssignmentRouter', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            // 默认界面
            .state('manageconfig.rolemanage.permissionassignment.iwo', {
                url: '/editingcenter/iwo',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'iwoPermissionAssignmentCtrl',
                    },
                },
            })
            .state('manageconfig.rolemanage.permissionassignment.paper', {
                url: '/editingcenter/paper',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/paper.html',
                        controller: 'newspaperPermissionAssignmentCtrl',
                    },
                },
            })
            .state('manageconfig.rolemanage.permissionassignment.web', {
                url: '/editingcenter/web',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main_batAuthority.html',
                        controller: 'websitePermissionAssignmentCtrl',
                    },
                },
            })
            .state('manageconfig.rolemanage.permissionassignment.app', {
                url: '/editingcenter/app',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main_batAuthority.html',
                        controller: 'appPermissionAssignmentCtrl',
                    },
                },
            })
            .state('manageconfig.rolemanage.permissionassignment.wechat', {
                url: '/editingcenter/wechat',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'wechatPermissionAssignmentCtrl',
                    },
                },
            })
            .state('manageconfig.rolemanage.permissionassignment.microblog', {
                url: '/editingcenter/microblog',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'weiboPermissionAssignmentCtrl',
                    },
                },
            })
            .state('manageconfig.rolemanage.permissionassignment.tv', {
                url: '/editingcenter/tv',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'tvPermissionAssignmentCtrl',
                    },
                },
            })
            .state('manageconfig.rolemanage.permissionassignment.broadcast', {
                url: '/editingcenter/broadcast',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'broadCastPermissionAssignmentCtrl',
                    },
                },
            })
            .state('manageconfig.rolemanage.permissionassignment.douyin', {
                url: '/editingcenter/douyin',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'trillPermissionAssignmentCtrl',
                    },
                },
            })
            .state('manageconfig.rolemanage.permissionassignment.baijiahao', {
                url: '/editingcenter/baijiahao',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'baijiahaoPermissionAssignmentCtrl',
                    },
                },
            })
            .state('manageconfig.rolemanage.permissionassignment.toutiao', {
                url: '/editingcenter/toutiao',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'toutiaoPermissionAssignmentCtrl',
                    },
                },
            })
            .state('manageconfig.rolemanage.permissionassignment.kuaibao', {
                url: '/editingcenter/kuaibao',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'qiehaoPermissionAssignmentCtrl',
                    },
                },
            })
            .state('manageconfig.rolemanage.permissionassignment.kuaishou', {
                url: '/editingcenter/kuaishou',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'kuaishouPermissionAssignmentCtrl',
                    },
                },
            })
            // 特权取稿
            .state('manageconfig.rolemanage.permissionassignment.privilegetaking', {
                url: '/editingcenter/privilegetaking',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/privilegeTaking_tpl.html',
                        controller: 'privilegeTakingCtrl',
                    },
                },
            })
            // 模块权限
            .state('manageconfig.rolemanage.permissionassignment.modulepermission', {
                url: '/modulepermission',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'modulePermissionCtrl',
                    },
                },
            })
            // 产品范围
            .state('manageconfig.rolemanage.permissionassignment.product', {
                url: '/product',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main_batAuthority.html',
                        controller: 'proRangeCtrl',
                    },
                },
            })
            // 组织范围
            .state('manageconfig.rolemanage.permissionassignment.group', {
                url: '/group',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main_batAuthority.html',
                        controller: 'orgRangeCtrl',
                    },
                },
            })
            // 用户管理
            .state('manageconfig.rolemanage.permissionassignment.user', {
                url: '/user',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'usermanagePerCtrl',
                    },
                },
            })
            // 策划中心协同指挥
            .state('manageconfig.rolemanage.permissionassignment.plCCommand', {
                url: '/plccommand',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'plCenterCommandCtrl',
                    },
                },
            })
            // 策划中心大屏控制
            .state('manageconfig.rolemanage.permissionassignment.plCLargeScreen', {
                url: '/plclargescreen',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'plCenterLargeScreenCtrl',
                    },
                },
            })
            // 资源中心
            .state('manageconfig.rolemanage.permissionassignment.resourcecenter', {
                url: '/resourcecenter?type',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'resourceCenterPermission',
                    },
                },
            })
            // 运营管理考核系统
            .state('manageconfig.rolemanage.permissionassignment.mtyas', {
                // 运营中心-新疆维吾尔自治区媒体云平台考核系统
                url: '/operationcenter/mtyas',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'mytAsCtrl',
                    },
                },
            })
            // 运营管理目数
            .state('manageconfig.rolemanage.permissionassignment.mushu', {
                // 运营中心-目数
                url: '/operationcenter/mushu',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'mushuCtrl',
                    },
                },
            })
            // 运营中心首页
            .state('manageconfig.rolemanage.permissionassignment.index', {
                // 运营中心-目数
                url: '/operationcenter/index',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'operateCenterIndexCtrl',
                    },
                },
            })
            // 网察大数据
            .state('manageconfig.rolemanage.permissionassignment.wangchabigdata', {
                url: '/cloudmarket',
                views: {
                    permission: {
                        templateUrl: './manageConfig/roleManageMent/permissionAssignment/template/main.html',
                        controller: 'wangchaPermissionCtrl',
                    },
                },
            });
    },
]);
